import { render, staticRenderFns } from "./Purpose.vue?vue&type=template&id=482ad931&scoped=true"
import script from "./Purpose.vue?vue&type=script&lang=js"
export * from "./Purpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ad931",
  null
  
)

export default component.exports